'use strict';

angular.module('adelementAdminApp').controller('AeAdvertisersDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'AeAdvertisers',
        function($scope, $stateParams, $uibModalInstance, entity, AeAdvertisers) {

        $scope.aeAdvertisers = entity;
        $scope.load = function(id) {
            AeAdvertisers.get({id : id}, function(result) {
                $scope.aeAdvertisers = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('adelementAdminApp:aeAdvertisersUpdate', result);
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };

        var onSaveError = function (result) {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.aeAdvertisers.id != null) {
                AeAdvertisers.update($scope.aeAdvertisers, onSaveSuccess, onSaveError);
            } else {
                AeAdvertisers.save($scope.aeAdvertisers, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        $scope.datePickerForTimezone = {};

        $scope.datePickerForTimezone.status = {
            opened: false
        };

        $scope.datePickerForTimezoneOpen = function($event) {
            $scope.datePickerForTimezone.status.opened = true;
        };
        $scope.datePickerForCreationTimestamp = {};

        $scope.datePickerForCreationTimestamp.status = {
            opened: false
        };

        $scope.datePickerForCreationTimestampOpen = function($event) {
            $scope.datePickerForCreationTimestamp.status.opened = true;
        };
}]);
